import { render, staticRenderFns } from "./growthModelGrowthFertilizer.vue?vue&type=template&id=17274bb1&scoped=true"
import script from "./growthModelGrowthFertilizer.vue?vue&type=script&lang=js"
export * from "./growthModelGrowthFertilizer.vue?vue&type=script&lang=js"
import style0 from "./growthModelGrowthFertilizer.vue?vue&type=style&index=0&id=17274bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17274bb1",
  null
  
)

export default component.exports